module.exports = __webpack_public_path__ + "static/media/logo.a54901e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 25
// module chunks = 0